import { Box, Button, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import React from 'react';
import CustomTextField from '../../components/forms/CustomTextField';
import * as Yup from 'yup';

const updateBranchValidationSchema = Yup.object({
    branch_name: Yup.string().required('Branch name is required'),
    branch_location: Yup.string().required('Branch location is required'),
}) 

// !############### MAIN FUNC ####################
const UpdateBranch = () => {
    return (
        <>
            <Formik
                initialValues={{
                    branch_name: '',
                    branch_location: '',
                }}
                validationSchema={updateBranchValidationSchema}
            >
                {(formik) => (
                    <Form>
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid item sm={12}>
                                <CustomTextField
                                    name="branch_name"
                                    label={'Branch name'}
                                    color="primary"
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <CustomTextField
                                    name="branch_location"
                                    label={'Branch location'}
                                    color="primary"
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        className="app-btn"
                                    >
                                        Update branch
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default UpdateBranch;
